import styled, { createGlobalStyle } from 'styled-components'

export const UserAccountEditModalGlobalStyle = createGlobalStyle`
  .user-account-edit-modal {
    .ant-modal-content {
      border-radius: 12px !important;
      overflow: hidden;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
    }

    .ant-modal-header {
      padding: 18px 24px !important;
      border-bottom: 1px solid #f1f5f9 !important;
      background: #ffffff !important;
    }

    .ant-modal-title {
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      font-size: 18px !important;
      font-weight: 600 !important;
      color: #0f172a !important;
    }

    .ant-modal-close {
      top: 18px !important;
      right: 20px !important;
      color: #64748b !important;

      &:hover {
        color: #0f172a !important;
      }
    }

    .ant-modal-body {
      padding: 24px !important;
      max-height: 82vh !important;
      overflow-y: auto !important;

      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: #e2e8f0;
        border-radius: 9999px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #cbd5e1;
      }
    }
  }
`

export const UserAccountEditFormWrapper = styled.div`
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .ant-form-item {
    margin-bottom: 16px;
  }

  .ant-form-item-label > label {
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #334155 !important;
    margin-bottom: 4px;
  }

  .password-info-icon {
    color: #94a3b8;
    margin-left: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: color 0.2s ease;

    &:hover {
      color: #1d68a5;
    }
  }

  .ant-input {
    height: 40px !important;
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    padding: 0 14px !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;

    &:hover:not(:disabled) {
      border-color: #93c5fd !important;
    }

    &:focus,
    &.ant-input-focused {
      border-color: #70aefb !important;
      box-shadow: 0 0 0 2px rgba(112, 174, 251, 0.2) !important;
    }

    &:disabled,
    &[disabled] {
      background: #f8fafc !important;
      color: #334155 !important;
      font-weight: 500 !important;
      border: 1px solid #e2e8f0 !important;
      cursor: not-allowed !important;
    }
  }

  .ant-input-affix-wrapper {
    height: 40px !important;
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    padding: 0 14px !important;
    display: flex !important;
    align-items: center !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;

    .ant-input {
      height: 38px !important;
      border: none !important;
      box-shadow: none !important;
      padding: 0 !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      font-size: 14px !important;
    }

    &:hover {
      border-color: #93c5fd !important;
    }

    &:focus,
    &.ant-input-affix-wrapper-focused {
      border-color: #70aefb !important;
      box-shadow: 0 0 0 2px rgba(112, 174, 251, 0.2) !important;
    }
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 40px !important;
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    padding: 0 14px !important;
    display: flex !important;
    align-items: center !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;

    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      line-height: 38px !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      font-size: 14px !important;
    }
  }

  .ant-select:hover .ant-select-selector {
    border-color: #93c5fd !important;
  }

  .ant-select.ant-select-focused .ant-select-selector {
    border-color: #70aefb !important;
    box-shadow: 0 0 0 2px rgba(112, 174, 251, 0.2) !important;
  }

  .ant-select-multiple {
    font-family: "Inter", Noto Sans Display, sans-serif !important;

    .ant-select-selector {
      min-height: 40px !important;
      border-radius: 8px !important;
      border: 1px solid #e2e8f0 !important;
      padding: 3px 8px !important;
      display: flex !important;
      align-items: center !important;
      flex-wrap: wrap !important;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    }

    &:hover .ant-select-selector {
      border-color: #93c5fd !important;
    }

    &.ant-select-focused .ant-select-selector {
      border-color: #70aefb !important;
      box-shadow: 0 0 0 2px rgba(112, 174, 251, 0.2) !important;
    }

    .ant-select-selection-item {
      background: #eff8ff !important;
      border: 1px solid #bae6fd !important;
      border-radius: 6px !important;
      color: #1d68a5 !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      height: 28px !important;
      line-height: 26px !important;
      padding: 0 8px !important;
      margin: 2px 4px 2px 0 !important;
      display: inline-flex !important;
      align-items: center !important;

      .ant-select-selection-item-remove {
        color: #70aefb !important;
        margin-left: 6px !important;

        &:hover {
          color: #ef4444 !important;
        }
      }
    }
  }
`

export const FormButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;

  .btn-cancel {
    height: 38px !important;
    padding: 0 18px !important;
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    color: #475569 !important;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    background: #ffffff !important;
    margin: 0 !important;
    transition: all 0.2s ease !important;

    &:hover {
      border-color: #cbd5e1 !important;
      background: #f8fafc !important;
      color: #1e293b !important;
    }
  }

  .btn-submit {
    height: 38px !important;
    padding: 0 22px !important;
    border-radius: 8px !important;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    background: #1d68a5 !important;
    border-color: #1d68a5 !important;
    color: #ffffff !important;
    box-shadow: 0 2px 6px rgba(29, 104, 165, 0.2) !important;
    transition: all 0.2s ease !important;

    &:hover {
      background: #155589 !important;
      border-color: #155589 !important;
      box-shadow: 0 4px 12px rgba(29, 104, 165, 0.3) !important;
    }
  }
`
